import { FC } from "react";
import { Route, Routes } from "react-router-dom";

import RegisterPage from "../components/auth/RegisterPage";
import Home from "../pages/Home"; // ← не обгорнутий тут в Layout
import LoginPage from "../components/auth/LoginPage";
import RegistrationConfirmation from "../components/auth/RegistrationConfirmation";
import AboutUs from "../pages/AboutUs"; // ← імпорт нової сторінки
import NewsListPage from "../pages/NewsListPage";
import NewsDetailsPage from "../pages/NewsDetailsPage";
import EducationalMaterials from "../pages/EducationalMaterials";
import Courses from "../pages/Courses";
import CourseDetailsPage from "../pages/CourseDetailsPage";
import RedirectUnknownRoutes from "./RedirectUnknownRoutes";

const UnAuthRoutes: FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:id" element={<NewsDetailsPage />} />
            <Route path="/about" element={<AboutUs />} /> {/* ← новий маршрут */}
            <Route path="/educational-materials" element={<EducationalMaterials />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetailsPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registration-confirmation" element={<RegistrationConfirmation />} />
            <Route path="*" element={<RedirectUnknownRoutes />} />
                    
        </Routes>
    );
};

export default UnAuthRoutes;
